export class BaseCountry {
  countryId: number;
  name: string;
  isoCode: string;
}
